module.exports = __webpack_public_path__ + "img/default.7fd6df98.png";